// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1___74df88421c1960744ce","cls2":"FeedbackModal-cls2___58ea5b1c54d01b9cb8b FeedbackModal-cls1___74df88421c1960744ce"};